import { Dialog } from 'primereact/dialog'
import { Dropdown } from 'primereact/dropdown'
import { useRevoke } from '../../Hooks/Features/Pocker/useRevoke'
import { calculateWordsFromString } from '../../utils/Helper';

const RevokePopup = ({ showPopup, handleClose, stage, apiCall }) => {
  const { option, handleRevoke, formValue, setFormValue, commonFilter } = useRevoke({ stage, showPopup, apiCall });


  return (
    <Dialog
      className="modal-xsmall"
      visible={showPopup?.show}
      draggable={false}
      onHide={handleClose}
      header={() => <div>Revoke</div>}

    >
      <div>
        <div className="my-2">
          <label>Select Move Stage</label>
          <Dropdown
            value={formValue?.status}
            placeholder="Select Move Stage"
            options={option?.status || []}
            optionLabel="bucket_status_name"
            optionValue='bucket_status_key'
            filter
            filterInputAutoFocus
            className="input-dd mb-0"
            onChange={(e) => setFormValue((prev) => ({ ...prev, status: e.value }))}
          />
        </div>

        {(stage === "finalized" && commonFilter?.taskType) &&
          <div>
            <div className="my-2 w100">
              <Dropdown value={formValue?.selected_reason} onChange={(e) => setFormValue((prev) => ({ ...prev, selected_reason: e?.target?.value }))} placeholder="Select a reason" options={option?.revoke_reasons} optionLabel="revoke_reason" filter filterInputAutoFocus className="input-dd w100 mb-0" />
            </div>
            {formValue?.selected_reason?.revoke_reason?.toLowerCase() === "other" && (
              <textarea className="w100" placeholder="Please add remark" value={formValue?.entered_reason} onChange={(e) => setFormValue((prev) => ({ ...prev, entered_reason: e?.target?.value }))} />
            )}
            <div className="d-flex justify-content-between">
              <div className="w50">
                {(formValue?.selected_reason?.revoke_reason?.toLowerCase() === "other" && calculateWordsFromString(formValue?.entered_reason || "") <= 5) ? calculateWordsFromString(formValue?.entered_reason || "") + "/5 words" : ""}
              </div>
            </div>
            <p className='rounded my-2 notes d-block'>
              <span className='fw-semibold'>Note:</span> Your revoke reason is being recorded for historical purposes. Ensure that you provide a valid reason.
            </p>
          </div>
        }

        {stage === "workspace" &&
          <div className='notes d-block my-2'>
            <span className='fw-semibold'>Note:</span> The selected task(s) will be moved from workspace to bucket tab in review.
          </div>
        }

        <div className='d-flex justify-content-end'>
          <button onClick={handleRevoke}>Submit</button>
        </div>
      </div>
    </Dialog>
  )
}

export default RevokePopup